<template>
	<div>
		<div id="tabs" class="container">
  
		    <div class="tabs">
            <a v-for="(list, index) in prop_owners" :key="index" v-on:click="activetab=index" v-bind:class="[ activetab == index ? 'active' : '' ]">Director - {{index+1}}</a>
            <a v-on:click="activetab=prop_owners.length" v-bind:class="[ activetab === prop_owners.length ? 'active' : '' ]">Other Details</a>
        </div>

        <div class="content">
            <div v-for="(list, index) in prop_owners" :key="index">
                <div v-if="activetab ===index" class="tabcontent">
                    <div class="col-md-12 p-l-r-0 f-left">
                        <div class="form-group col-md-6  f-left">
                            <p class="qustion_label">Name (in full)</p>
                            <p class="ans_label">{{list.name}}</p>
                        </div>
                        <div class="form-group col-md-6  f-left">
                            <p class="qustion_label">Father’s Name (in full)</p>
                            <p class="ans_label">{{list.father_name}}</p>
                        </div>
                    </div>
                    <div class="col-md-12 p-l-r-0 f-left">
                        <div class="form-group col-md-6  f-left">
                            <p class="qustion_label">Mobile Number</p>
                            <p class="ans_label">{{list.mobile_no}}</p>
                        </div>
                        <div class="form-group col-md-6  f-left">
                            <p class="qustion_label">Email ID</p>
                            <p class="ans_label">{{list.email_id}}</p>
                        </div>
                    </div>
                    <div class="col-md-12 p-l-r-0 f-left">
                        <div class="form-group col-md-6  f-left">
                            <p class="qustion_label">Date of Birth</p>
                            <p class="ans_label">{{list.dob | FormatDate('DD-MM-YYYY')}}</p>
                        </div>
                        <div class="form-group col-md-6  f-left">
                            <p class="qustion_label">Highest Educational Qualification</p>
                            <p class="ans_label">{{list.higest_education}}</p>
                        </div>
                    </div>
                    <div class="col-md-12 p-l-r-0 f-left">
                        <div class="form-group col-md-6  f-left">
                            <p class="qustion_label">Occupation</p>
                            <p class="ans_label">{{list.occupation}}</p>
                        </div>
                        <div class="form-group col-md-6  f-left">
                            <p class="qustion_label">PAN Number</p>
                            <p class="ans_label">{{list.pan_number}} </p>
                        </div>
                    </div>
                    <div class="col-md-12 p-l-r-0 f-left">
                        <div class="form-group col-md-6  f-left">
                            <p class="qustion_label">Address</p>
                            <p class="ans_label">{{list.address}}</p>
                        </div>
                        <div class="form-group col-md-6  f-left">
                            <p class="qustion_label">Address Proof</p>
                            <p class="ans_label">Address.pdf <span><a :href="list.address_url" download><img src="../assets/download_icon.png" style="width: auto;"></a></span></p>
                        </div>
                    </div>
                    <div class="col-md-12 p-l-r-0 f-left">

                        <div class="form-group col-md-6  f-left">
                            <p class="qustion_label">PAN (Self-Attested)</p>
                            <p class="ans_label">PAN.pdf <span><a :href="list.pan_url"><img src="../assets/download_icon.png" style="width: auto;"></a></span></p>
                        </div>
                        <div class="form-group col-md-6  f-left">
                            <p class="qustion_label">Aadhar (Self-Attested)</p>
                            <p class="ans_label">Aadhar.pdf <span><a :href="list.aadhar_url"><img src="../assets/download_icon.png" style="width: auto;"></a></span></p>
                        </div>
                    </div>
                    <div class="col-md-12 p-l-r-0 f-left">

                        <div class="form-group col-md-6  f-left">
                            <p class="qustion_label">Passport size photo</p>
                            <p class="ans_label">Passport.pdf <span><a :href="list.passport_size_photo"><img src="../assets/download_icon.png" style="width: auto;"></a></span></p>
                        </div>
                    </div>
                    <div class="col-md-12 p-l-r-0 f-left border-seperator"></div>
                    <div class="col-md-12 p-l-r-0 f-left">
                        <div class="form-group col-md-6  f-left">
                            <p class="qustion_label">Do you have Digital Signature Certificate?</p>
                            <p class="ans_label">{{list.dsc}}</p>
                        </div>
                        <div class="form-group col-md-6  f-left">
                            <p class="qustion_label">Do you have Director Identification Number (DIN)?</p>
                            <p class="ans_label">{{list.din}} <span v-if="list.din=='yes'">{{list.din_other}}</span></p>
                        </div>
                    </div>
                    <div class="col-md-12 p-l-r-0 f-left">
                        <div class="form-group col-md-6  f-left">
                            <p class="qustion_label">Are you an Indian citizen?</p>
                            <p class="ans_label">{{list.citizen_of_india=='yes' ? 'India' : list.citizen_of_india_other}}</p>
                        </div>
                        <div class="form-group col-md-6  f-left">
                            <p class="qustion_label">Ownership percentage</p>
                            <p class="ans_label">{{list.ownership_percentage}}</p>
                        </div>
                    </div>
                    <div class="col-md-12 p-l-r-0 f-left">
                        <div class="form-group col-md-6  f-left">
                            <p class="qustion_label">Do you have an interest in any other entity?</p>
                            <p class="ans_label">{{list.intrested_in_other_entity}}</p>
                        </div>
                    </div>
                    <div v-if="list.intrested_in_other_entity=='yes'">
                        <div class="col-md-12 p-l-r-0 f-left sub-text">
                            <span>Nature of interest (owner/partner/director etc.)</span>
                        </div>
                        <div class="col-md-12 f-left nature_interest_box" v-for="interest in list.nature_interest_list" :key="interest.id">
                            <div class="col-md-12 p-l-r-0 f-left">
                                <div class="form-group col-md-6  f-left">
                                    <p class="qustion_label">Name of the Entity</p>
                                    <p class="ans_label">{{interest.entity_name}}</p>
                                </div>
                                <div class="form-group col-md-6  f-left" style="padding-left: 0px!important;padding-right: 0!important">
                                    <p class="qustion_label">Nature of Interest owner/partner/director etc.</p>
                                    <p class="ans_label">{{interest.nature_interest_interest}}</p>
                                </div>
                            </div>
                            <div class="col-md-12 p-l-r-0 f-left">
                                <div class="form-group col-md-6  f-left">
                                    <p class="qustion_label">Value in INR</p>
                                    <p class="ans_label">{{interest.value}}</p>
                                </div>
                                <div class="form-group col-md-6  f-left" style="padding-left: 0px!important;padding-right: 0!important">
                                    <p class="qustion_label">Date</p>
                                    <p class="ans_label">{{interest.date | FormatDate('DD-MM-YYYY')}}</p>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
		        <div v-if="activetab =='2'" class="tabcontent">
		            <div class="col-md-12 p-l-r-0 f-left">
						<div class="form-group col-md-6  f-left">
							<p class="qustion_label">Website (if available)</p>
	            			<p class="ans_label">{{prop_others.website}}</p>
		                </div>
		            </div>
		            <div class="col-md-12 p-l-r-0 f-left">
		                <div class="form-group col-md-12  f-left">
							<p class="qustion_label">    Please add a brief note about your business objective. </p>
	            			<p class="ans_label">
								{{prop_others.brief_note}}
							 </p>
		                </div>
		            </div>
		            <div class="col-md-12 p-l-r-0 f-left form-group">
		            	<p class="qustion_label" >Proposed Company Name</p>
		                <div class=" col-md-6 p-l-r-0 f-left">
							
	            			<p class="ans_label">{{prop_others.proposed_company_name_option1}}</p>
		                </div>
		                <div class="col-md-6 p-r-0 f-left">
	            			<p class="ans_label">{{prop_others.proposed_company_name_option2}}</p>
		                </div>
					</div>
					
					<div class="col-md-12 p-l-r-0 f-left">
		                <div class="form-group col-md-6  f-left">
							<p class="qustion_label">Authorised Capital</p>
	            			<p class="ans_label">{{prop_others.authorized_capital ? prop_others.authorized_capital :'NA'}}</p>
		                </div>
		                <div class="form-group col-md-6  f-left">
							<p class="qustion_label">Paid Up Capital</p>
	            			<p class="ans_label">{{prop_others.paid_up_capital ? prop_others.paid_up_capital :'NA'}}</p>
		                </div>
					</div>
					<div class="col-md-12 p-l-r-0 f-left">
		                <div class="form-group col-md-6  f-left">
							<p class="qustion_label">Registered office address of proposed company</p>
	            			<p class="ans_label">{{prop_others.registered_office ? prop_others.registered_office : 'NA'}}</p>
		                </div>
					</div>
					<div class="col-md-12 p-l-r-0 f-left upload_document" style="display:none">
		                <div class="form-group col-md-6  f-left">
							<p class="qustion_label">Upload Documents</p>
	            			<p class="ans_label">Documents.pdf <span><a href="#"><img src="../assets/download_icon.png" style="width: auto;"></a></span></p>
	            			<p class="ans_label">Documents.pdf <span><a href="#"><img src="../assets/download_icon.png" style="width: auto;"></a></span></p>
		                </div>
		                
					</div>
		        </div>
		    </div>
		  
		</div>
	</div>
</template>

<script>
export default {
    name:'pvt_form_preview',
	 props: ['prop_owners', 'prop_others'],
     watch:{
   
    },
    data() {
        return {
        	activetab: 0
        }
    },
    methods: {

    }
};

</script>